// extracted by mini-css-extract-plugin
export default {"details":"styles_details__C81Ap","heading":"styles_heading__IL9nt","hr":"styles_hr__34S-4","field":"styles_field__gBbPR","fields":"styles_fields__gR2Md","form":"styles_form__31y6k"};